import { defineMessages } from "react-intl";

const messages = defineMessages({
    teaching: {
        id: "teacherPage.experience",
    },
    joining: {
        id: "teacherPage.join",
    },
    language: {
        id: "account.language",
    },
    listedPlans: {
        id: "teacherPage.listedPlans",
    },
});

export default messages;
